import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { NO_RESET_WHITE_LIST } from '@/constants'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/analysis',
    meta: {},
    name: 'Dashboard',
    children: [
      {
        path: 'analysis',
        component: () => import('@/views/Dashboard/Analysis.vue'),
        name: 'Analysis',
        meta: {
          title: '分析页',
          icon: 'ant-design:dashboard-filled'
        }
      }
    ]
  },
  // {
  //   path: '/admin',
  //   component: Layout,
  //   meta: {},
  //   name: 'Admin',
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/Admin/Admin.vue'),
  //       name: 'AdminIndex',
  //       meta: {
  //         title: '管理员',
  //         icon: 'clarity:administrator-line'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/video',
    component: Layout,
    meta: {
      title: '视频管理',
      icon: 'bxs:videos'
    },
    redirect: 'VideoIndex',
    name: 'VideoList',
    children: [
      {
        path: 'index',
        component: () => import('@/views/Video/Index.vue'),
        name: 'VideoIndex',
        meta: {
          title: '视频列表'
        }
      },
      {
        path: 'rawIndex',
        component: () => import('@/views/Video/RawVideo.vue'),
        name: 'RawVideoIndex',
        meta: {
          title: '原视频列表'
        }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    meta: {},
    name: 'UserList',
    children: [
      {
        path: 'index',
        component: () => import('@/views/User/Index.vue'),
        name: 'UserIndex',
        meta: {
          title: '用户管理',
          icon: 'iconoir:user'
        }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    meta: {},
    name: 'OrderList',
    children: [
      {
        path: 'index',
        component: () => import('@/views/Order/Index.vue'),
        name: 'OrderIndex',
        meta: {
          title: '订单管理',
          icon: 'material-symbols:orders-outline'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
